import React from "react";
import styled from "styled-components";

import { useAuth } from "../../../hooks/useAuth.jsx";
import {
  getPaymentStatus,
  updateOrderPaymentStatus,
} from "../../../services/orderService.js";
import { useSearchParams } from "react-router-dom";

import { BsCart4 } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  p {
    text-align: center;
  }
`;

const Title = styled.h2`
  color: var(--primary-brown);
  padding: 8px;
`;

const ResponseTitle = styled.h3`
  color: var(--primary-brown);
  margin: 0;
  text-align: center;
`;

const PaymentResultPage = () => {
  const token = window.localStorage.getItem("token");
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const { data: paymentStatus } = useQuery({
    queryKey: ["details", orderId],
    queryFn: () => getPaymentStatus(orderId),
    enabled: !!orderId,
  });

  // "orderNumber": "26",
  //  "orderStatus": 6,
  //    "actionCode": -100,
  //"actionCodeDescription": "Invalid CVV",
  const getPaymentStatusFromCode = (orderStatus) => {
    if (orderStatus === 1 || orderStatus === 2)
      return "Plată realizată cu succes!";
    else if (orderStatus === 0 || orderStatus === 6)
      return "Plata nu a fost realizată! Puteți încerca din nou accesând secțiunea 'Contul meu'!";
    return "Status necunoscut";
  };
  const getPaymentStatusText = (actionCode, actionCodeDescription) => {
    switch (actionCode) {
      case 104:
      case 124:
      case 320:
      case 801:
        return "Cardul nu a fost acceptat, iar plata nu poate fi autorizată!";

      case 803:
      case 804:
      case 913:
      case 914:
        return "Tranzacția nu este permisă. Contactați banca emitentă!";

      case 805:
      case 861:
      case 871:
      case 905:
      case 906:
      case 915:
      case 917:
        return actionCodeDescription;

      case 341016:
      case 341017:
      case 341018:
      case 341019:
      case 341020:
        return "Verificarea 3DS2 a eșuat!";

      default:
        return "S-a produs o eroare la procesarea plății!";
    }
  };

  return (
    <Container>
      <BsCart4
        style={{
          fontSize: "100px",
          color: "var(--primary-brown)",
          margin: "0 auto",
        }}
      />
      <Title>
        {paymentStatus?.orderStatus === 1 || paymentStatus?.orderStatus === 2
          ? "Comanda a fost plasată cu succes!"
          : "Comanda a fost plasată cu succes, dar plata a eșuat!"}
      </Title>
      <ResponseTitle>
        {paymentStatus?.orderStatus
          ? getPaymentStatusFromCode(paymentStatus?.orderStatus)
          : "Status necunoscut"}
      </ResponseTitle>
      {paymentStatus?.orderStatus !== 1 && paymentStatus?.orderStatus !== 2 && (
        <p style={{ color: "var(--primary-brown)" }}>
          {paymentStatus?.actionCode
            ? getPaymentStatusText(
                paymentStatus?.actionCode,
                paymentStatus?.actionCodeDescription
              )
            : "S-a produs o eroare la procesarea plății!"}
        </p>
      )}
      <p style={{ color: "var(--primary-brown)", margin: "0" }}>
        Te vom contacta în cel mai scurt timp. Mulțumim !
      </p>
    </Container>
  );
};

export default PaymentResultPage;
